import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetLaboratory,
	adminGetAllLaboratories,
	resetFocusLaboratory,
	initNewLaboratory,
	adminPatchLaboratory,
	adminPostLaboratory,
	adminDeleteLaboratory
} from 'services/laboratory';
import { adminGetAllLabParamGroups } from 'services/labParamGroup';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/Laboratories/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	name: Yup.string().required('Champ requis'),
	ip_range: Yup.string(),
	folder_num_format: Yup.string(),
	labParamGroup: Yup.object().shape({ id: Yup.number() })
});

class LaboratoriesAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
		this.props.adminGetAllLabParamGroups();
	}

	componentWillUnmount() {
		this.props.resetFocusLaboratory();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllLaboratories();
	};

	focusOnElement = elt => {
		this.props.adminGetLaboratory(elt);
	};

	onAddClick = () => {
		this.props.initNewLaboratory();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostLaboratory(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchLaboratory(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteLaboratory(this.props.laboratories.focus.data);
	};

	render() {
		const { laboratories, labParamGroups } = this.props;
		const { focus, list } = laboratories;
		const laboratory = focus.data;
		const newLaboratory = laboratory !== null && laboratory.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={laboratories.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity='LABORATOIRES'
					addButtonText='Nouveau laboratoire'
					onAddButtonClick={this.onAddClick}
					defaultLabel={e => e.name}
					groupField={false}
					focusedEltId={laboratory}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity='Laboratoires'
					icon='info'
				>
					{laboratory !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: laboratory.id,
								name: laboratory.name || '',
								ip_range: laboratory.ip_range || '',
								folder_num_format: laboratory.folder_num_format || '',
								labParamGroup: { id: laboratory.labParamGroup?.id || '' }
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusLaboratory}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newLaboratory ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newLaboratory && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={e => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm labParamGroups={labParamGroups} />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex'
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0'
	}
};

const mapStateToProps = state => {
	return {
		laboratories: state.admin.laboratories,
		labParamGroups: state.admin.labParamGroups
	};
};

const mapDispatchToProps = {
	adminGetAllLaboratories,
	adminGetLaboratory,
	adminPatchLaboratory,
	adminDeleteLaboratory,
	resetFocusLaboratory,
	adminPostLaboratory,
	initNewLaboratory,
	adminGetAllLabParamGroups
};

export default connect(mapStateToProps, mapDispatchToProps)(LaboratoriesAdmin);
